import { Link } from "react-router-dom";
import { LegalLayout } from "../components/LegalLayout";

export default function CommercialRelationships() {
  return (
    <LegalLayout title="Commercial Relationships" description="A transparent overview of the commercial and affiliate relationships that fund VoiceRanker.ai." updated="July 2026" testId="commercial-relationships-page">
      <p>This page provides a transparent overview of the commercial relationships that fund the operation of VoiceRanker.ai, a website operated by <strong>Digital Media Strategies Ltd</strong>.</p>

      <h2>Current Affiliate Relationships</h2>
      <p>At the time of publication, VoiceRanker.ai maintains an affiliate relationship with:</p>
      <ul>
        <li><strong>ElevenLabs</strong> — if you sign up through qualifying links on this website, we may earn a commission at no additional cost to you.</li>
      </ul>
      <p>We do not currently maintain affiliate relationships with Murf.ai, PlayHT, Lovo.ai, Resemble.ai or the other providers referenced on this website. Links to those providers are provided for reader convenience only.</p>

      <h2>What This Means for Our Content</h2>
      <p>Affiliate relationships never determine our editorial comparisons, rankings or recommendations. Companies cannot pay for a higher ranking or a more favourable recommendation. Our approach to evaluation and ranking is described in our <Link to="/editorial-policy">Editorial Standards &amp; Ranking Policy</Link>, and full details of how affiliate links work are set out in our <Link to="/affiliate-disclosure">Affiliate Disclosure</Link>.</p>

      <h2>Sponsored Content</h2>
      <p>VoiceRanker.ai does not currently publish sponsored content. If any content is ever sponsored or commercially funded, it will be clearly identified as such.</p>

      <h2>Questions</h2>
      <p>Questions about our commercial relationships can be directed to:<br />Email: <a href="mailto:support@voiceranker.ai">support@voiceranker.ai</a></p>
    </LegalLayout>
  );
}
